export const transformUserDefinedSkillSuggestions = suggestions => {
  const skillAssignments = suggestions.flatMap(
    item => item.skillAssignments || [item]
  );

  const userDefinedSkillData = suggestions.map(skill => ({
    skillAssignments: [
      {
        ...skill,
        displayText: skill.skillName,
        skillLevel: {
          uri: skill.skillLevelUri,
          rating: skill.skillLevel
        },
        nudgeId: skill.nudgeId
      }
    ]
  }));

  const addSkills = skillAssignments.map(skillAssignment => ({
    skillName: skillAssignment.displayText || skillAssignment.skillName,
    skillLevelId:
      skillAssignment.skillLevel?.uri || skillAssignment.skillLevelUri
  }));

  const nudgeIds = [];

  skillAssignments.forEach(skillAssignment => {
    if (skillAssignment.nudgeId) {
      nudgeIds.push(skillAssignment.nudgeId);
    }
  });

  return {
    skillAssignments,
    userDefinedSkillData,
    addSkills,
    nudgeIds
  };
};

export const transformSystemSkillSuggestions = systemLevelSkills => {
  const systemSkillCategories = systemLevelSkills.reduce((acc, nudge) => {
    const categoryKey = nudge.categoryName;

    if (!acc[categoryKey]) {
      acc[categoryKey] = {
        category: {
          id: nudge.categoryUri,
          uri: nudge.categoryUri,
          displayText: nudge.categoryName
        },
        skillAssignments: []
      };
    }

    acc[categoryKey].skillAssignments.push(
      transformSuggestionToSkillAssignment(nudge)
    );

    return acc;
  }, {});

  return Object.values(systemSkillCategories);
};

export const transformSuggestionToSkillAssignment = suggestion => ({
  id: suggestion.skillUri,
  uri: suggestion.skillUri,
  displayText: suggestion.skillName,
  skillLevel: {
    id: suggestion.skillLevelUri,
    uri: suggestion.skillLevelUri,
    displayText: suggestion.skillLevelName,
    rating: suggestion.skillLevel
  },
  certificate: null,
  skillCustomMetadata: [],
  isDelaRecommendation: true,
  nudgeId: suggestion.nudgeId
});
